export function CorrectionIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4.00016 4.00001L5.3335 2.66668M5.3335 2.66668L4.00016 1.33334M5.3335 2.66668H4.00016C2.5274 2.66668 1.3335 3.86058 1.3335 5.33334M12.0002 12L10.6668 13.3333M10.6668 13.3333L12.0002 14.6667M10.6668 13.3333H12.0002C13.4729 13.3333 14.6668 12.1394 14.6668 10.6667M8.94494 8.94479C9.46645 9.19388 10.0504 9.33334 10.6668 9.33334C12.876 9.33334 14.6668 7.54248 14.6668 5.33334C14.6668 3.1242 12.876 1.33334 10.6668 1.33334C8.45769 1.33334 6.66683 3.1242 6.66683 5.33334C6.66683 5.94982 6.80629 6.53373 7.05538 7.05523M9.3335 10.6667C9.3335 12.8758 7.54264 14.6667 5.3335 14.6667C3.12436 14.6667 1.3335 12.8758 1.3335 10.6667C1.3335 8.45754 3.12436 6.66668 5.3335 6.66668C7.54264 6.66668 9.3335 8.45754 9.3335 10.6667Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
